/** @format */

import React, { Component } from 'react';
import { Dropdown, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('SalesStore')
@observer
class SaleShippingType extends Component {
  render() {
    const { SalesStore } = this.props;
    return (
      <Segment>
        <p style={{ marginBottom: '0' }}>
          <small>
            <strong>Tipologia ritiro:</strong>
          </small>
        </p>
        <Dropdown
          label="Tipologia ritiro"
          value={SalesStore.currentSale.data.shippingType}
          onChange={(e, selection) =>
            SalesStore.handleShippingTypeSelect(selection.value)
          }
          placeholder="Tipologia Spedizione"
          selection
          options={[
            { text: 'Spedizione', value: 'spedizione', key: 'spedizione' },
            {
              text: 'Ritiro in magazzino',
              value: 'ritiro in magazzino',
              key: 'ritiro',
            },
            {
              text: 'Trasferimento a sede di Cagliari',
              value: 'trasferimento a sede di Cagliari',
              key: 'trasferimento',
            },
          ]}
          fluid
          size="small"
        ></Dropdown>
      </Segment>
    );
  }
}

export default SaleShippingType;
